import { WorkspaceUntypedData } from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTOWorkspaceUntypedData = WorkspaceUntypedData;

export const DTOWorkspaceUntypedDataListResponse = z.object({
  data: DTOWorkspaceUntypedData.array(),
});

export const DTOWorkspaceUntypedDataResponse = z.object({
  data: DTOWorkspaceUntypedData,
});

export type DTOWorkspaceUntypedData = z.infer<typeof DTOWorkspaceUntypedData>;
export type DTOWorkspaceUntypedDataListResponse = z.infer<typeof DTOWorkspaceUntypedDataListResponse>;
export type DTOWorkspaceUntypedDataResponse = z.infer<typeof DTOWorkspaceUntypedDataResponse>;

//
// Write
//

export const DTOWorkspaceUntypedDataCreatePayload = z.object({
  value: z.unknown(),
});

export const DTOWorkspaceUntypedDataUpdatePayload = z.object({
  value: z.unknown(),
});

export type DTOWorkspaceUntypedDataCreatePayload = z.infer<typeof DTOWorkspaceUntypedDataCreatePayload>;
export type DTOWorkspaceUntypedDataUpdatePayload = z.infer<typeof DTOWorkspaceUntypedDataUpdatePayload>;
